export default {
  $el: 'section',
  attrs: {
    class: 'incident-type',
  },
  children: [
    {
      $formkit: 'radio',
      name: 'type',
      label: 'What type of incident is this?',
      options: [
        {
          label: 'Web / App',
          value: 'Technology',
          help: 'An incident that impacts customers using the Web or mobile Apps. For example the website being down.',
        },
        {
          label: 'Factory or Fulfillment',
          value: 'Factory',
          help: 'An incident that impacts our factories. e.g. A machine breaking down.',
        },
        {
          label: 'Security',
          value: 'Security',
          help: 'An incident where security is the main implication. e.g. a data breach, malware or stolen laptop.',
        },
        {
          label: 'Office / IT',
          value: 'OfficeIt',
          help: 'An incident where staff are the main implication. e.g. Gsuite issues, network or VPN problems.',
        },
        {
          label: 'Data',
          value: 'Data',
          help: 'An incident where the data platform has been impacted. e.g. A broken data pipeline results in inaccurate reporting.',
        },
        {
          label: 'Facilities or Health & Safety incident',
          value: 'Facilities',
          help: 'An incident that impacts our facilities or the health and safety of those working for or with Moonpig Group.',
        },
      ],
    },
  ],
}

export { default as detailsFormConfig } from './sections/details.js'
export { default as webAppFormConfig } from './sections/webApp.js'
export { default as securityFormConfig } from './sections/security.js'
export { default as fulfilmentFormConfig } from './sections/fulfilment.js'
export { default as facilitiesFormConfig } from './sections/facilities.js'
export { default as officeFormConfig } from './sections/office.js'
export { default as dataFormConfig } from './sections/data.js'

export { customInputs } from './plugins.js'
